<div id="detailDialog" class="bottom-dialog-container text">
  <eventdetail-component [eventIdByInput]="this.matchId" *ngIf="this.matchId != 0 && !this.isLive"></eventdetail-component>
  <liveeventdetail-component [eventIdByInput]="this.matchId" *ngIf="this.matchId != 0 && this.isLive"></liveeventdetail-component>
</div>
